<template>
    <div class="p-10" v-if="data!=null && !process">
        <div class="row floating-labels align-items-center justify-content-end">
            <div class="col-auto">
                <formGroup :title="'Acenta Komisyonu'" :as="'checkbox'" class="m-b-0" v-model="isCommission"></formGroup>
            </div>
            <div class="col-auto">
                <formGroup :as="'select'" v-model="type" :errors="{}">
                    <template #input>
                        <option value="PP">PP</option>
                        <option value="Daily">Daily</option>
                        <option value="DBL">DBL</option>
                        <option value="DBLCHD">DBLCHD</option>
                        <option value="Package">Package</option>
                        <option value="Flight">Flight</option>
                    </template>
                </formGroup>
            </div>
        </div>
    </div>
  <LineChart :chart-data="data" :options="options" css-classes="chart-container"></LineChart>
</template>

<script>
    import {LineChart} from "vue-chart-3"
    import {Chart, Legend,Title,Tooltip, BarController, CategoryScale,LinearScale,BarElement,LineController,LineElement,PointElement,Filler} from "chart.js"
    Chart.register(Legend,Title,Tooltip,BarController,CategoryScale,LinearScale,BarElement,LineController,LineElement,PointElement,Filler);
    
    export default {
        components:{LineChart},
        props:["operationData","CurrencyCode","Commission"],
        data(){
            return {
                isCommission:false,
                type:"PP",
                data:{
                    labels:[],
                    datasets:[
                        {
                            label: 'Ortalama Üst Limit',
                            backgroundColor: 'rgba(0, 99, 132,0.2)',
                            borderColor: 'rgba(255, 99, 132,0)',
                            tension: 0.4,
                            parsing: true,
                            data:[]
                            // fill: '-1',
                            // type:"bar"
                        },
                        {
                            label: 'Ortalama Alt Limit',
                            backgroundColor: 'rgba(0, 99, 132,0.2)',
                            borderColor: 'rgba(255, 99, 132,0)',
                            tension: 0.4,
                            fill: "-1",
                            data:[],
                            options: {
                                datalabels: {
                                    display: false //This will do the task
                                }
                            }
                            // type:"bar"
                        }
                    ]
                },
                options:{
                    height:400,
                    responsive: true,
                    datalabels: {
                        display: false,
                    },
                    legend: {
                        display: false
                    },
                    interaction: {
                        mode: 'index',
                        intersect: false,
                    }
                },
                colors:[
                    "rgba(71,135,50,1)",
                    "rgba(120,147,48,1)",
                    "rgba(180,161,46,1)",
                    "rgba(223,171,44,1)",
                    "rgba(255,178,43,1)",
                    "rgba(250,146,51,1)",
                    "rgba(244,114,58,1)",
                    "rgba(239,86,64,1)",
                    "rgba(235,66,69,1)",
                    "rgba(230,41,75,1)"
                ],
                colorIndex:[]
            }
        },
        created(){
            this.create(true);
        },
        watch:{
            CurrencyCode(){
                this.create();
            },
            isCommission(){
                this.create();
            },
            operationData(){
                this.create(true);
            },
            type(){
                this.create();
            }
        },
        methods:{
            create(newColor=false){
                if(newColor){
                    this.colorIndex=[];
                    for (let index = 0; index < 100; index++) {
                        this.colorIndex.push(this.colors[Math.floor(Math.random() * 10)]);
                    }
                }
                this.data={
                    labels:[],
                    datasets:[
                        {
                            label: 'Ortalama Üst Limit',
                            backgroundColor: 'rgba(0, 150, 136, 0.2)',
                            borderColor: 'rgba(0, 150, 136, 0.2)',
                            tension: 0.4,
                            parsing: true,
                            showLine:false,
                            pointRadius:0,
                            radius:0,
                            data:[]
                            // fill: '-1',
                            // type:"bar"
                        },
                        {
                            label: 'Ortalama Alt Limit',
                            backgroundColor: 'rgba(0, 150, 136, 0.2)',
                            borderColor: 'rgba(0, 150, 136, 0.2)',
                            tension: 0.4,
                            fill: "-1",
                            pointRadius:0,
                            showLine:false,
                            data:[],
                            order:50,
                            options: {
                                datalabels: {
                                    display: false //This will do the task
                                }
                            }
                            // type:"bar"
                        }
                    ]
                };
                var dates={}
                this.operationData.Dates.forEach(element => {
                    this.data.labels.push(this.$dateFormat(new Date(element)).substring(0,5));
                    dates[element]={};
                });
                this.operationData.MinPrices.forEach(element => {
                    if(element[this.type]>0){
                        if(dates[element.Checkin].low==null){
                            dates[element.Checkin].low=this.$exchangeCurrency({EUR:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].EUR,USD:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].USD},element.CurrencyCode,element[this.type],this.CurrencyCode,element.CurrencyCode);
                            dates[element.Checkin].high=this.$exchangeCurrency({EUR:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].EUR,USD:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].USD},element.CurrencyCode,element[this.type],this.CurrencyCode,element.CurrencyCode);
                        }else{
                            if(dates[element.Checkin].low>this.$exchangeCurrency({EUR:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].EUR,USD:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].USD},element.CurrencyCode,element[this.type],this.CurrencyCode,element.CurrencyCode)){
                                dates[element.Checkin].low=this.$exchangeCurrency({EUR:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].EUR,USD:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].USD},element.CurrencyCode,element[this.type],this.CurrencyCode,element.CurrencyCode);
                            }
                            if(dates[element.Checkin].high<this.$exchangeCurrency({EUR:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].EUR,USD:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].USD},element.CurrencyCode,element[this.type],this.CurrencyCode,element.CurrencyCode)){
                                dates[element.Checkin].high=this.$exchangeCurrency({EUR:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].EUR,USD:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].USD},element.CurrencyCode,element[this.type],this.CurrencyCode,element.CurrencyCode);
                            }
                        }
                    }
                });
                this.operationData.Dates.forEach(date => {
                    if(this.isCommission){
                        this.data.datasets[0].data.push(dates[date].high/100*(100-this.Commission)).toFixed(2);
                        this.data.datasets[1].data.push(dates[date].low/100*(100-this.Commission)).toFixed(2);
                    }else{
                        this.data.datasets[0].data.push(dates[date].high).toFixed(2);
                        this.data.datasets[1].data.push(dates[date].low).toFixed(2);
                    }
                    
                });
            
                // ----------
                var hotels={};
                this.operationData.Hotels.forEach(element => {
                    hotels[element.Id]={};
                    this.operationData.Dates.forEach(date => {
                        hotels[element.Id][date]=[];
                    });
                });
                this.operationData.MinPrices.forEach(element => {
                    if(element[this.type]>0){
                        if(this.isCommission){
                            hotels[element.HotelId][element.Checkin].push((this.$exchangeCurrency({EUR:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].EUR,USD:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].USD},element.CurrencyCode,element[this.type],this.CurrencyCode,element.CurrencyCode))/100*(100-this.Commission));
                        }else{
                            hotels[element.HotelId][element.Checkin].push(this.$exchangeCurrency({EUR:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].EUR,USD:this.operationData.Operators.filter(x=>x.Id==element.OperatorId)[0].USD},element.CurrencyCode,element[this.type],this.CurrencyCode,element.CurrencyCode));
                        }
                    }
                });
                this.operationData.Hotels.forEach((hotel,index) => {
                    var set={
                        label: hotel.Name,
                        backgroundColor: this.colorIndex[index],
                        borderColor: this.colorIndex[index],
                        tension: 0.4,
                        data:[]
                    }
                    var data=[];
                    Object.entries(hotels[hotel.Id]).forEach((date) => {
                        var datePrice=0;
                        date[1].forEach(price => {
                            datePrice+=price;
                        });
                        data.push(datePrice/date[1].length);
                    });
                    set.data=data;
                    this.data.datasets.push(set);
                });
            }
        }
    }
</script>

<style scoped>
    /deep/  canvas{
        height:400px !important;
    }
</style>